    import React from 'react';
    
    const CircleBlue = () => {
        return (
            <div className='header__circle-blue'>
                
            </div>
        );
    };
    
    export default CircleBlue;